// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fileGenericBasicForm__hint[data-v-c73f1b34]{margin:8px 0 0;font-size:var(--link-text-sm);color:var(--link-text-muted,#6b6560)}", ""]);
// Exports
module.exports = exports;
